import { useContext, useState } from "react";
import CustomDataTable from "../components/dataTable";
import DownloadIcon from '../icons/download';
import CustomDateRangeInput from "../components/dateRangeInput";
import { ToastDataContext } from "../context/ToastContextProvider";
import { UserDataContext } from "../context/UserContextProvider";
import { hrEmployeeReportEndpoint } from "../hr_endpoints";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function HRReports({ }) {

    const { t } = useTranslation();

    const [reportsData, setReportsData] = useState([
        {
            code: "EMPLOYEE_REPORT",
            name: t("reports.employeeReport"),
        },
    ])

    const toastContext = useContext(ToastDataContext)
    const userContext = useContext(UserDataContext)

    const [reportRange, setReportRange] = useState({
        startDate: null,
        endDate: null
    })
    const navigate = useNavigate()

    const onDownloadReport = async (code) => {
        const startDate = reportRange.startDate ? dayjs(reportRange.startDate).format("YYYY-MM-DD") : ""
        const endDate = reportRange.endDate ? dayjs(reportRange.endDate).format("YYYY-MM-DD") : ""

        if (!startDate || !endDate) {
            toastContext.error(t("reports.invalidDateRange"))
            return
        }

        switch (code) {
            case "EMPLOYEE_REPORT":
                const response = await fetch(hrEmployeeReportEndpoint(startDate, endDate), {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                        "Content-Disposition": "attachment; filename=report.xlsx",
                        "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                        "Authorization": `Bearer ${userContext.user?.token}`
                    }
                })
                if (response.status === 401) {
                    userContext.setUserData({})
                    navigate('/login')
                    toastContext.error(t("sessionExpired"));
                }
                const data = await response.blob()
                const url = window.URL.createObjectURL(new Blob([data]))
                const a = document.createElement('a')
                a.href = url
                a.download = "report.xlsx"
                document.body.appendChild(a)
                a.click()
                a.remove()
                break
            default:
                toastContext.error(t("reports.reportNotAvailable"))
        }
    }

    const columns = [
        {
            accessorKey: "name", // Matches the key in your data
            header: t("reports.name"),
        },
        {
            accessorKey: "actions",
            header: t("reports.actions"),
            cell: ({ row }) => (
                <span onClick={() => { onDownloadReport(row.original.code) }}>
                    <DownloadIcon className="size-7 cursor-pointer fill-primary" />
                </span>
            )
        }
    ];

    const [pagination, setPagination] = useState({
        pageIndex: 0, // Current page index (zero-based)
        pageSize: 10, // Number of rows per page
    });

    const [sorting, setSorting] = useState([
        {
            id: "name",
            desc: false
        },
    ])

    return (
        <div>
            <h1 className="font-headingH3 pb-10">{t("reports.reports")}</h1>
            <div className="flex flex-row gap-5 mb-4 ml-4">
                <div className="max-w-[410px] min-w-[270px]">
                    <label htmlFor="contract_date" className="block font-subtitle text-neutral-1100 mb-2">{t("reports.reportDate")}</label>
                    <CustomDateRangeInput value={reportRange} onChange={newValue => setReportRange(newValue)} />
                </div>
            </div>
            <CustomDataTable
                data={reportsData}
                columns={columns}
                pagination={pagination}
                pageCount={10}
                sorting={sorting}
                onSortingChange={() => { }}
                onPaginationChange={() => { }}
                isSortable={false}
                isPaginable={false}
            />
        </div>
    )

}